import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCC_ENDPOINTS } from '@city/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { MyShopService } from '../services';

@Injectable({ providedIn: 'root' })
export class MyShopInterceptor implements HttpInterceptor {
  constructor(
    private myShopsService: MyShopService,
    private occEndpoints: OccEndpointsService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      request.url.includes(this.occEndpoints.getBaseUrl()) &&
      // Через бейзсторы запрашиваются магазины, поэтому чтобы не попасть в цикл
      // игнорируем этот url
      !request.url.includes(this.occEndpoints.buildUrl(OCC_ENDPOINTS.baseStores))
    ) {
      return this.myShopsService.activeShop$.pipe(map((shop) => shop?.name)).pipe(
        first(),
        switchMap((shopName: string | undefined) => {
          if (shopName) {
            request = request.clone({
              setParams: {
                pointOfService: shopName,
              },
            });
          }

          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
